/* avatar.icon.svg.js */

"use strict";
module.exports = {
    icon: `
            <svg viewBox="-301 385 24 24" preserveAspectRatio="none">
                <path class="foreground-gl" d="M-282.6,400.7c0,0-3.4-0.4-3.5-3.6c0.5-0.5,0.9-1.3,1.2-2.2c0.1,0,0.1,0,0.3,0c0.5-0.1,1.2-0.9,1.3-1.9s-0.3-1.3-0.8-1.3
                    c0.5-0.7,0.9-6.6-4.9-6.6c-6.1,0-5.4,5.9-5,6.6c-0.5,0.1-0.9,0.5-0.8,1.3c0.1,0.9,0.8,1.8,1.3,1.9c0.1,0,0.3,0,0.3,0
                    c0.3,0.8,0.7,1.6,1.2,2.2c-0.1,3.1-3.4,3.5-3.4,3.5c-4.4,0.4-4.6,6.5-4.3,7.1c0.3,0.7,2.4,1.3,10.7,1.3c8.5,0,10.4-0.7,10.7-1.3
                    C-277.9,407.2-278.2,401.1-282.6,400.7z"/>
            </svg>
        `,
};
